const industries = [
  "Med Spa",
  "Dental",
  "Chiropractic",
  "Restaurant",
  "Coffee Shop",
  "Salon / Beauty",
  "Home Services",
  "Auto Services",
  "Healthcare",
  "Fitness",
  "Retail",
  "Professional Services",
  "Other",
];

export default function BusinessDetailsStep({
  form,
  onChange,
  onNext,
  loading,
  error,
}) {
  return (
    <form onSubmit={onNext} className="space-y-5">
      {error && (
        <div className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
          {error}
        </div>
      )}

      <Field
        label="Business Name"
        name="name"
        placeholder="Joe's Coffee Shop"
        value={form.name}
        onChange={onChange}
        required
      />

      <SelectField
        label="Industry"
        name="industry"
        value={form.industry}
        onChange={onChange}
        required
        options={industries}
      />

      {form.industry === "Other" && (
        <Field
          label="Custom Industry"
          name="customIndustry"
          placeholder="Enter your industry"
          value={form.customIndustry}
          onChange={onChange}
          required
        />
      )}

      <Field
        label="Business Email"
        name="email"
        type="email"
        placeholder="owner@business.com"
        value={form.email}
        onChange={onChange}
        required
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Field
          label="Website"
          name="website"
          type="url"
          placeholder="https://yourbusiness.com"
          value={form.website}
          onChange={onChange}
        />

        <Field
          label="Phone"
          name="phone"
          type="tel"
          placeholder="(614) 555-0198"
          value={form.phone}
          onChange={onChange}
        />
      </div>

      <button
        type="submit"
        disabled={loading}
        className="w-full rounded-xl bg-indigo-600 px-4 py-3 text-sm font-medium text-white hover:bg-indigo-700 disabled:opacity-60 disabled:cursor-not-allowed transition"
      >
        {loading ? "Creating business..." : "Continue"}
      </button>
    </form>
  );
}

function Field({ label, ...props }) {
  return (
    <label className="block">
      <span className="text-sm font-medium text-slate-700">{label}</span>

      <input
        {...props}
        className="mt-1.5 w-full rounded-xl border border-slate-200 bg-slate-50 px-4 py-2.5 text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition"
      />
    </label>
  );
}

function SelectField({ label, options, ...props }) {
  return (
    <label className="block">
      <span className="text-sm font-medium text-slate-700">{label}</span>

      <select
        {...props}
        className="mt-1.5 w-full rounded-xl border border-slate-200 bg-slate-50 px-4 py-2.5 text-slate-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition"
      >
        <option value="">Select an industry</option>

        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </label>
  );
}
